import { render, staticRenderFns } from "./OccupationForm.vue?vue&type=template&id=4db492be&scoped=true&"
import script from "./OccupationForm.vue?vue&type=script&lang=js&"
export * from "./OccupationForm.vue?vue&type=script&lang=js&"
import style0 from "./OccupationForm.vue?vue&type=style&index=0&id=4db492be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db492be",
  null
  
)

export default component.exports